module.exports = __webpack_public_path__ + "img/appxw.5379840f.png";